import BlGhostblockPaginationMv from './BlGhostblockPaginationMv.vue'

BlGhostblockPaginationMv.install = function(Vue) {
  Vue.component(BlGhostblockPaginationMv.name, BlGhostblockPaginationMv)
}

export default BlGhostblockPaginationMv
